import { frontendURL } from '../../../helper/URLHelper';
import CrmIndex from './pages/CrmIndex.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    component: CrmIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'crm_index',
        component: CrmIndex,
        meta: commonMeta,
      },
      {
        path: 'pipelines/:pipelineId',
        name: 'crm_pipeline',
        component: CrmIndex,
        meta: commonMeta,
        props: true,
      },
    ],
  },
];
